import { GroupBy } from '../../store/constants';
import { useTranslation } from 'react-i18next';
import { globalErrorResponse } from '../../shared/notification/actions';
import { invalidateSelectionListAggregations } from '../../shop/selectionlists/useSelectionListAggregations';
import { invalidateSelectionListSummary } from './useSelectionListSummary';
import { invalidateSelectionListGroupedItems } from './useSelectionListGroupedItems';
import { invalidateSelectionListProducts } from '../../shop/selectionlists/api/useSelectionListProducts';
import { http } from '../axios';
import { shopPrefix } from '../../config';
import { showNotification } from '../../shared/notification/toastNotification';

type Group = { key: GroupBy; id: string };

const buildRemoveGroupedItemsCallback = (listId: string, bundleId: string): (() => Promise<void>) => {
    const pathParams = {
        listId,
        bundleId
    };

    return () => http.put(`${shopPrefix}/v2/selectionlists/:listId/bulk/bundle/:bundleId/remove`, {}, { pathParams });
};

export const useRemoveGroupedItemFromList = ({ listId }: { listId: string }) => {
    const { t } = useTranslation();

    return {
        removeGroupedItem: async (group: Group) => {
            const apiCallback = buildRemoveGroupedItemsCallback(listId, group.id);
            try {
                await apiCallback();
                showNotification(t('notifications.removeProductsFromList.message'));
                invalidateSelectionListAggregations(listId).then();
                invalidateSelectionListSummary(listId).then();
                invalidateSelectionListGroupedItems(listId).then();
                invalidateSelectionListProducts(listId).then();
            } catch (error: any) {
                globalErrorResponse(error);
                invalidateSelectionListGroupedItems(listId).then();
            }
        }
    };
};
